module.exports = __webpack_public_path__ + "static/media/Brands_7.b5cf6807.png";